import { render, staticRenderFns } from "./MenuOfferList.vue?vue&type=template&id=f2ead5a8&scoped=true&"
import script from "./MenuOfferList.vue?vue&type=script&lang=ts&"
export * from "./MenuOfferList.vue?vue&type=script&lang=ts&"
import style0 from "./MenuOfferList.vue?vue&type=style&index=0&id=f2ead5a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ead5a8",
  null
  
)

export default component.exports